import React from 'react';
import { Outlet } from 'react-router-dom';
import ConsultancyFooter from '../components/ConsultancyElements/ConsultancyFooter';
import ConsultancyHeader from '../components/ConsultancyElements/ConsultancyHeader';
import ScrollToTop from '../components/common/ScrollToTop/ScrollToTop';
import ScrollTop from '../scrolltop/ScrollTop';
const ConsultancyLayout = () => {      
    return (
        <>
            <>
                {/* <div className="page-wrapper"> */}
                <ConsultancyHeader />
                <Outlet />
                <ConsultancyFooter />
                {/* </div> */}
            </>
             <ScrollTop />
            <ScrollToTop />
        </>
    );
};

export default ConsultancyLayout;